module.exports = __webpack_public_path__ + "media/images/pokerroom/888/description-pict-bbe0cff03489ee4c126909a51af5a258.jpg";